import type { AuthResources } from '../en/auth';

export const auth: AuthResources = {
  actions: {
    signOut: 'Abmelden',
    retry: 'Erneut versuchen',
    contactSupport: 'Support kontaktieren',
  },
  login: {
    title: 'Bei fleetster anmelden',
    description: 'Melden Sie sich mit Ihrem Konto an, um fortzufahren.',
    emailLabel: 'E-Mail',
    passwordLabel: 'Passwort',
    submit: 'Anmelden',
    submitting: 'Anmeldung läuft…',
    failed: 'Anmeldung fehlgeschlagen.',
    quickLoginAriaLabel: 'Schnellanmeldung',
  },
  quickLogin: {
    title: 'Schnellanmeldung',
    description:
      'Wählen Sie einen Seed-Benutzer aus, um die Zugangsdaten auszufüllen und sich anzumelden. Jedes Konto verwendet das Passwort',
  },
  gate: {
    title: 'Kein Arbeitsbereich verfügbar',
    description:
      'Ihr Konto ist noch mit keiner Organisation verknüpft, daher kann das Onboarding nicht fortgesetzt werden. Bitte kontaktieren Sie den Support, um Zugang zu erhalten.',
  },
  onboarding: {
    title: 'Willkommen bei fleetster',
    description: 'Lassen Sie uns die Einrichtung Ihres Kontos abschließen, bevor Sie fortfahren.',
  },
  pending: {
    title: 'Warten auf Freischaltung',
    description:
      'Ihr Zugang zu {{workspace}} steht noch aus. Ein Administrator muss Sie freischalten, bevor Sie fortfahren können.',
    fallbackWorkspace: 'diesem Arbeitsbereich',
  },
  deactivated: {
    title: 'Konto deaktiviert',
    description: 'Ihr Konto wurde deaktiviert. Bitte kontaktieren Sie den Support, um es wieder zu aktivieren.',
  },
  noTenants: {
    title: 'Keine Mandanten verknüpft',
    description:
      'Mit Ihrem Konto sind keine Organisationen verknüpft. Bitte kontaktieren Sie den Support, falls Sie Zugang erwartet haben.',
  },
  serverError: {
    title: 'Server nicht erreichbar',
    description:
      'Ihre Sitzung konnte nicht geladen werden. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  },
  tenants: {
    title: 'Arbeitsbereich auswählen',
    description:
      'Wählen Sie die Organisation, in der Sie arbeiten möchten. Inaktive oder ausstehende Arbeitsbereiche können noch nicht betreten werden.',
  },
  revocation: {
    toast: 'Ihr Datenfreigabe-Zugriff auf {{tenant}} ist beendet. Sie werden zu {{home}} gewechselt.',
  },
};
